import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSingleTracking,
  getBulkTracking,
} from "../../../api/postalTracking_api";

export const getSingleTrackingAction = createAsyncThunk(
  "postalTracking/getSingleTracking",
  async (trackingNumber, { rejectWithValue }) => {
    try {
      const response = await getSingleTracking(trackingNumber);
      return response.data ?? response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getBulkTrackingAction = createAsyncThunk(
  "postalTracking/getBulkTracking",
  async (bulk, { rejectWithValue }) => {
    try {
      const response = await getBulkTracking(bulk);
      return response.data ?? response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
